import { setWasmUrl } from '@lottiefiles/dotlottie-react';

/**
 * Self-host the dotlottie WebAssembly binary instead of letting the library
 * fetch it from a CDN (cdn.jsdelivr.net / unpkg.com).
 *
 * Our backend sets a strict CSP (`script-src 'self' 'wasm-unsafe-eval'`), which
 * blocks loading/instantiating WASM from external origins. The matching
 * `dotlottie-player.wasm` (same version as @lottiefiles/dotlottie-web) is copied
 * into `client/public/`, so it is served same-origin and satisfies the CSP.
 *
 * Importing this module triggers the side effect exactly once (ES module cache),
 * and it must run before any DotLottie instance initializes — hence it is
 * imported at the top of the animation components.
 */
setWasmUrl(`${process.env.PUBLIC_URL || ''}/dotlottie-player.wasm`);
